import { Controller } from "@hotwired/stimulus"

// Narrows a long list of checkboxes as you type (each item carries its lower-cased text in data-search).
export default class extends Controller {
  static targets = ["input", "item"]

  filter() {
    const needle = this.inputTarget.value.trim().toLowerCase()
    this.itemTargets.forEach((item) => { item.hidden = needle !== "" && !item.dataset.search.includes(needle) })
  }
}
